export default __webpack_public_path__ + "5c7cea77c0fa271c534fcea1c4e59b72.png";